module.exports = __webpack_public_path__ + "static/recommend_2024-a2747078003e307835f5dcb1a937abae.svg";